import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { GuiaListMem } from "app/features/general/operativa/items/guias/listados/guias/list/listmem";
import { FirmaCadenaComponent } from "app/features/componentes/firmacadena";

type Entity = models.EntregaOcurreDTOListas;
export interface Props {
    value: Entity;
}

const ImprimirButton = kea.defaultProps(kea.Button, { children: "Imprimir acuses internos", iconClass: fa("print") });

/**
* Componente para editar un Entity
*/
export class EntregaOcurreFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    onImprimirAcuses = async () => {
        const data = await resources.EntregaOcurre.ImprimirAcusesInternos(this.props.value.IdRegistro);
        await kea.printPdf(data);
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Check = getField(kea.Checkbox);
        const Number = getField(kea.Number);
        const Date = getField(kea.DateTime);
        return (
            <div>
                <kea.Title titulo="Entrega a ocurre" onRegresar={() => history.go("../")} >
                    <ImprimirButton onClick={this.onImprimirAcuses} />
                </kea.Title>

                {kea.autogrid(3, [
                    <Date field="Fecha" time />,
                    <Text field="NombreUsuario" label="Usuario" />,
                    <Text field="NombreCliente" label="Cliente" />,
                    <Text field="NombreContactoCliente" label="Contacto" />,
                    <Number field="CantGuias" label="Cant. guias" />,
                    <Number field="CantAcusesInternos" label="Cant. acuses internos" />,
                ])}

                <FirmaCadenaComponent label="Firma" value={value.FirmaUsuario} />
                <GuiaListMem value={value.Guias} />
            </div>);
    }
}

export const EntregaOcurreDTOForm = componentToRx(EntregaOcurreFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/edit/form.tsx